module.exports = __webpack_public_path__ + "static/media/4.870e2ff9.jpg";